import { useContext, useEffect, useState } from 'react';
import ActionCard from './ActionCard'; 
import LocationReviewCardListProps from '../interfaces/LocationReviewCardListProps';
import LocationReview from '../interfaces/LocationReview';
import '../styles/CardList.css'
import AppContext from '../context/AppContext';
import dbActions from '../utils/db';
import MyReviewsContext from '../context/MyReviewsContext';

const LocationReviewCardList: React.FC<LocationReviewCardListProps> = ({ specificUser }) => {
  const [locationReviews, setLocationReviews] = useState<LocationReview[]>([]);
  const { refreshReviews, setRefreshReviews } = useContext(MyReviewsContext);
  const { user } = useContext(AppContext);

  useEffect(() => {
    (async () => {
      try {
        const userData = (await dbActions.getUserFromEmail(user?.email!)).user;
        const retrievedReviews = await dbActions.getUserReviews(userData);
        setLocationReviews(retrievedReviews);
        setRefreshReviews(false);
      } catch (error) {
        console.error("Error fetching location reviews:", error);
      }
    })();
  }, [user, refreshReviews]);

  return (
    <>
      {locationReviews.length !== 0 ? 
        <h3 className='shadowed' style={{color: 'white'}}>Tus reseñas:</h3> 
        : <h3 className='shadowed' style={{color: 'white'}}>Parece que aún no has creado reseñas</h3>
      }
      <section className='card-container'>
        <div className="card-list">
          {locationReviews.map((locationReview) => (
            <ActionCard
              locationReview={locationReview}
            />)
            )}
        </div>
      </section>
    </>
  );
};

export default LocationReviewCardList;
